import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import Alert from '../compo/alert';
import Cookies from 'js-cookie';

const AlertActionsContext = createContext();

const AlertStateContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertActionsContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const useAlertState = () => {
  const context = useContext(AlertStateContext);
  if (!context) {
    throw new Error('useAlertState must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [hideMenu, setHideMenu] = useState(false);
  const [isAlertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('info');

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowSize;
  }

  const Gfunc = require("../Gfunc");
  const size = useWindowSize();
  const [noMenu, setNoMenu] = useState(
    (size.width >= Gfunc.smallScreen) 
      ? JSON.parse(Cookies.get(`comapct${localStorage.getItem("uid")}`) ?? "false") 
      : true
  );

  const showAlert = useCallback((message, alertSeverity = 'info') => {
    setAlertMessage(message);
    setSeverity(alertSeverity);
    setAlertVisible(true);
  }, []);

  useEffect(() => {
    let timer;
    if (isAlertVisible) {
      timer = setTimeout(() => {
        setAlertVisible(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [isAlertVisible]);

  const hideAlert = useCallback(() => {
    setAlertVisible(false);
    setAlertMessage('');
    setSeverity('info');
  }, []);

  const handleOpenMenu = useCallback((val) => {
    setOpenMenu(val);
  }, []);

  const handleHideMenu = useCallback((val) => {
    setHideMenu(val);
  }, []);

  const handleNoMenu = useCallback((val) => {
    Cookies.set(`comapct${localStorage.getItem("uid")}`, JSON.stringify(val), { expires: 7 });
    setNoMenu(val);
  }, []);

  const actionsValue = useMemo(() => ({
    showAlert,
    hideAlert,
    handleOpenMenu,
    handleHideMenu,
    handleNoMenu,
  }), [showAlert, hideAlert, handleOpenMenu, handleHideMenu, handleNoMenu]);

  const stateValue = useMemo(() => ({
    isAlertVisible,
    alertMessage,
    severity,
    openMenu,
    hideMenu,
    noMenu,
  }), [isAlertVisible, alertMessage, severity, openMenu, hideMenu, noMenu]);

  return (
    <AlertActionsContext.Provider value={actionsValue}>
      <AlertStateContext.Provider value={stateValue}>
        {isAlertVisible && <Alert />}
        {children}
      </AlertStateContext.Provider>
    </AlertActionsContext.Provider>
  );
};